/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type {
  TokenContract,
  TokenContractInterface,
} from "../../../../contracts/fwen/FwenMultiStaker.sol/TokenContract";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "bool[]",
        name: "locks",
        type: "bool[]",
      },
    ],
    name: "lockTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transferLocks",
    outputs: [
      {
        internalType: "enum tokenContract.LockStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class TokenContract__factory {
  static readonly abi = _abi;
  static createInterface(): TokenContractInterface {
    return new utils.Interface(_abi) as TokenContractInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TokenContract {
    return new Contract(address, _abi, signerOrProvider) as TokenContract;
  }
}
